function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useEventCallback } from '@mui/material/utils';
import { GridSignature, useGridApiEventHandler } from "../../utils/useGridApiEventHandler.js";
import { useGridApiMethod } from "../../utils/useGridApiMethod.js";
import { useGridLogger } from "../../utils/useGridLogger.js";
import { useGridSelector } from "../../utils/useGridSelector.js";
import { gridRowsLookupSelector, gridRowMaximumTreeDepthSelector, gridRowTreeSelector } from "../rows/gridRowsSelector.js";
import { gridRowSelectionStateSelector, selectedGridRowsSelector, selectedIdsLookupSelector } from "./gridRowSelectionSelector.js";
import { gridPaginatedVisibleSortedGridRowIdsSelector } from "../pagination/index.js";
import { gridFocusCellSelector } from "../focus/gridFocusStateSelector.js";
import { gridExpandedSortedRowIdsSelector, gridFilteredRowsLookupSelector } from "../filter/gridFilterSelector.js";
import { GRID_CHECKBOX_SELECTION_COL_DEF, GRID_ACTIONS_COLUMN_TYPE } from "../../../colDef/index.js";
import { GridCellModes } from "../../../models/gridEditRowModel.js";
import { isKeyboardEvent, isNavigationKey } from "../../../utils/keyboardUtils.js";
import { getVisibleRows } from "../../utils/useGridVisibleRows.js";
import { GRID_DETAIL_PANEL_TOGGLE_FIELD } from "../../../internals/constants.js";
import { gridClasses } from "../../../constants/gridClasses.js";
import { isEventTargetInPortal } from "../../../utils/domUtils.js";
import { isMultipleRowSelectionEnabled, findRowsToSelect, findRowsToDeselect } from "./utils.js";
var getSelectionModelPropValue = function(selectionModelProp, prevSelectionModel) {
    if (selectionModelProp == null) {
        return selectionModelProp;
    }
    if (Array.isArray(selectionModelProp)) {
        return selectionModelProp;
    }
    if (prevSelectionModel && prevSelectionModel[0] === selectionModelProp) {
        return prevSelectionModel;
    }
    return [
        selectionModelProp
    ];
};
export var rowSelectionStateInitializer = function(state, props) {
    var _getSelectionModelPropValue;
    return _extends({}, state, {
        rowSelection: props.rowSelection ? (_getSelectionModelPropValue = getSelectionModelPropValue(props.rowSelectionModel)) !== null && _getSelectionModelPropValue !== void 0 ? _getSelectionModelPropValue : [] : []
    });
};
/**
 * @requires useGridRows (state, method) - can be after
 * @requires useGridParamsApi (method) - can be after
 * @requires useGridFocus (state) - can be after
 * @requires useGridKeyboardNavigation (`cellKeyDown` event must first be consumed by it)
 */ export var useGridRowSelection = function(apiRef, props) {
    var _props_rowSelectionPropagation, _props_rowSelectionPropagation1, _props_rowSelectionPropagation2, _props_rowSelectionPropagation3, _props_rowSelectionPropagation4, _props_rowSelectionPropagation5, _props_rowSelectionPropagation6, _props_rowSelectionPropagation7, _props_rowSelectionPropagation8;
    var logger = useGridLogger(apiRef, 'useGridSelection');
    var runIfRowSelectionIsEnabled = React.useCallback(function(callback) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (props.rowSelection) {
                callback.apply(void 0, _to_consumable_array(args));
            }
        };
    }, [
        props.rowSelection
    ]);
    var applyAutoSelection = props.signature !== GridSignature.DataGrid && (((_props_rowSelectionPropagation = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation === void 0 ? void 0 : _props_rowSelectionPropagation.parents) || ((_props_rowSelectionPropagation1 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation1 === void 0 ? void 0 : _props_rowSelectionPropagation1.descendants));
    var propRowSelectionModel = React.useMemo(function() {
        return getSelectionModelPropValue(props.rowSelectionModel, gridRowSelectionStateSelector(apiRef.current.state));
    }, [
        apiRef,
        props.rowSelectionModel
    ]);
    var lastRowToggled = React.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: gridRowSelectionStateSelector,
        changeEvent: 'rowSelectionChange'
    });
    var checkboxSelection = props.checkboxSelection, disableRowSelectionOnClick = props.disableRowSelectionOnClick, propIsRowSelectable = props.isRowSelectable;
    var canHaveMultipleSelection = isMultipleRowSelectionEnabled(props);
    var tree = useGridSelector(apiRef, gridRowTreeSelector);
    var isNestedData = useGridSelector(apiRef, gridRowMaximumTreeDepthSelector) > 1;
    var expandMouseRowRangeSelection = React.useCallback(function(id) {
        var endId = id;
        var _lastRowToggled_current;
        var startId = (_lastRowToggled_current = lastRowToggled.current) !== null && _lastRowToggled_current !== void 0 ? _lastRowToggled_current : id;
        var isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            var visibleRowIds = gridExpandedSortedRowIdsSelector(apiRef);
            var startIndex = visibleRowIds.findIndex(function(rowId) {
                return rowId === startId;
            });
            var endIndex = visibleRowIds.findIndex(function(rowId) {
                return rowId === endId;
            });
            if (startIndex === endIndex) {
                return;
            }
            if (startIndex > endIndex) {
                endId = visibleRowIds[endIndex + 1];
            } else {
                endId = visibleRowIds[endIndex - 1];
            }
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    /*
   * API METHODS
   */ var setRowSelectionModel = React.useCallback(function(model) {
        if (props.signature === GridSignature.DataGrid && !canHaveMultipleSelection && Array.isArray(model) && model.length > 1) {
            throw new Error([
                'MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.',
                'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'
            ].join('\n'));
        }
        var currentModel = gridRowSelectionStateSelector(apiRef.current.state);
        if (currentModel !== model) {
            logger.debug("Setting selection model");
            apiRef.current.setState(function(state) {
                return _extends({}, state, {
                    rowSelection: props.rowSelection ? model : []
                });
            });
            apiRef.current.forceUpdate();
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        canHaveMultipleSelection
    ]);
    var isRowSelected = React.useCallback(function(id) {
        return gridRowSelectionStateSelector(apiRef.current.state).includes(id);
    }, [
        apiRef
    ]);
    var isRowSelectable = React.useCallback(function(id) {
        if (props.rowSelection === false) {
            return false;
        }
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) {
            return false;
        }
        var rowNode = gridRowTreeSelector(apiRef)[id];
        if ((rowNode === null || rowNode === void 0 ? void 0 : rowNode.type) === 'footer' || (rowNode === null || rowNode === void 0 ? void 0 : rowNode.type) === 'pinnedRow') {
            return false;
        }
        return true;
    }, [
        apiRef,
        props.rowSelection,
        propIsRowSelectable
    ]);
    var getSelectedRows = React.useCallback(function() {
        return selectedGridRowsSelector(apiRef);
    }, [
        apiRef
    ]);
    var selectRow = React.useCallback(function(id) {
        var isSelected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, resetSelection = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (!apiRef.current.isRowSelectable(id)) {
            return;
        }
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug("Setting selection for row ".concat(id));
            var newSelection = [];
            var addRow = function(rowId) {
                newSelection.push(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) {
                    var _props_rowSelectionPropagation, _props_rowSelectionPropagation1;
                    var _props_rowSelectionPropagation_descendants, _props_rowSelectionPropagation_parents;
                    findRowsToSelect(apiRef, tree, id, (_props_rowSelectionPropagation_descendants = (_props_rowSelectionPropagation = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation === void 0 ? void 0 : _props_rowSelectionPropagation.descendants) !== null && _props_rowSelectionPropagation_descendants !== void 0 ? _props_rowSelectionPropagation_descendants : false, (_props_rowSelectionPropagation_parents = (_props_rowSelectionPropagation1 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation1 === void 0 ? void 0 : _props_rowSelectionPropagation1.parents) !== null && _props_rowSelectionPropagation_parents !== void 0 ? _props_rowSelectionPropagation_parents : false, addRow);
                }
            }
            apiRef.current.setRowSelectionModel(newSelection);
        } else {
            logger.debug("Toggling selection for row ".concat(id));
            var selection = gridRowSelectionStateSelector(apiRef.current.state);
            var newSelection1 = new Set(selection);
            newSelection1.delete(id);
            var addRow1 = function(rowId) {
                newSelection1.add(rowId);
            };
            var removeRow = function(rowId) {
                newSelection1.delete(rowId);
            };
            if (isSelected) {
                addRow1(id);
                if (applyAutoSelection) {
                    var _props_rowSelectionPropagation2, _props_rowSelectionPropagation3;
                    var _props_rowSelectionPropagation_descendants1, _props_rowSelectionPropagation_parents1;
                    findRowsToSelect(apiRef, tree, id, (_props_rowSelectionPropagation_descendants1 = (_props_rowSelectionPropagation2 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation2 === void 0 ? void 0 : _props_rowSelectionPropagation2.descendants) !== null && _props_rowSelectionPropagation_descendants1 !== void 0 ? _props_rowSelectionPropagation_descendants1 : false, (_props_rowSelectionPropagation_parents1 = (_props_rowSelectionPropagation3 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation3 === void 0 ? void 0 : _props_rowSelectionPropagation3.parents) !== null && _props_rowSelectionPropagation_parents1 !== void 0 ? _props_rowSelectionPropagation_parents1 : false, addRow1);
                }
            } else if (applyAutoSelection) {
                var _props_rowSelectionPropagation4, _props_rowSelectionPropagation5;
                var _props_rowSelectionPropagation_descendants2, _props_rowSelectionPropagation_parents2;
                findRowsToDeselect(apiRef, tree, id, (_props_rowSelectionPropagation_descendants2 = (_props_rowSelectionPropagation4 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation4 === void 0 ? void 0 : _props_rowSelectionPropagation4.descendants) !== null && _props_rowSelectionPropagation_descendants2 !== void 0 ? _props_rowSelectionPropagation_descendants2 : false, (_props_rowSelectionPropagation_parents2 = (_props_rowSelectionPropagation5 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation5 === void 0 ? void 0 : _props_rowSelectionPropagation5.parents) !== null && _props_rowSelectionPropagation_parents2 !== void 0 ? _props_rowSelectionPropagation_parents2 : false, removeRow);
            }
            var isSelectionValid = newSelection1.size < 2 || canHaveMultipleSelection;
            if (isSelectionValid) {
                apiRef.current.setRowSelectionModel(Array.from(newSelection1));
            }
        }
    }, [
        apiRef,
        logger,
        applyAutoSelection,
        tree,
        (_props_rowSelectionPropagation2 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation2 === void 0 ? void 0 : _props_rowSelectionPropagation2.descendants,
        (_props_rowSelectionPropagation3 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation3 === void 0 ? void 0 : _props_rowSelectionPropagation3.parents,
        canHaveMultipleSelection
    ]);
    var selectRows = React.useCallback(function(ids) {
        var isSelected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, resetSelection = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        logger.debug("Setting selection for several rows");
        var selectableIds = ids.filter(function(id) {
            return apiRef.current.isRowSelectable(id);
        });
        var newSelection;
        if (resetSelection) {
            if (isSelected) {
                newSelection = new Set(selectableIds);
                if (applyAutoSelection) {
                    var addRow = function(rowId) {
                        newSelection.add(rowId);
                    };
                    selectableIds.forEach(function(id) {
                        var _props_rowSelectionPropagation, _props_rowSelectionPropagation1;
                        var _props_rowSelectionPropagation_descendants, _props_rowSelectionPropagation_parents;
                        findRowsToSelect(apiRef, tree, id, (_props_rowSelectionPropagation_descendants = (_props_rowSelectionPropagation = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation === void 0 ? void 0 : _props_rowSelectionPropagation.descendants) !== null && _props_rowSelectionPropagation_descendants !== void 0 ? _props_rowSelectionPropagation_descendants : false, (_props_rowSelectionPropagation_parents = (_props_rowSelectionPropagation1 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation1 === void 0 ? void 0 : _props_rowSelectionPropagation1.parents) !== null && _props_rowSelectionPropagation_parents !== void 0 ? _props_rowSelectionPropagation_parents : false, addRow);
                    });
                }
            } else {
                newSelection = new Set();
            }
            var currentLookup = selectedIdsLookupSelector(apiRef);
            if (newSelection.size === Object.keys(currentLookup).length && Array.from(newSelection).every(function(id) {
                return currentLookup[id] === id;
            })) {
                return;
            }
        } else {
            newSelection = new Set(Object.values(selectedIdsLookupSelector(apiRef)));
            var addRow1 = function(rowId) {
                newSelection.add(rowId);
            };
            var removeRow = function(rowId) {
                newSelection.delete(rowId);
            };
            selectableIds.forEach(function(id) {
                if (isSelected) {
                    newSelection.add(id);
                    if (applyAutoSelection) {
                        var _props_rowSelectionPropagation, _props_rowSelectionPropagation1;
                        var _props_rowSelectionPropagation_descendants, _props_rowSelectionPropagation_parents;
                        findRowsToSelect(apiRef, tree, id, (_props_rowSelectionPropagation_descendants = (_props_rowSelectionPropagation = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation === void 0 ? void 0 : _props_rowSelectionPropagation.descendants) !== null && _props_rowSelectionPropagation_descendants !== void 0 ? _props_rowSelectionPropagation_descendants : false, (_props_rowSelectionPropagation_parents = (_props_rowSelectionPropagation1 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation1 === void 0 ? void 0 : _props_rowSelectionPropagation1.parents) !== null && _props_rowSelectionPropagation_parents !== void 0 ? _props_rowSelectionPropagation_parents : false, addRow1);
                    }
                } else {
                    removeRow(id);
                    if (applyAutoSelection) {
                        var _props_rowSelectionPropagation2, _props_rowSelectionPropagation3;
                        var _props_rowSelectionPropagation_descendants1, _props_rowSelectionPropagation_parents1;
                        findRowsToDeselect(apiRef, tree, id, (_props_rowSelectionPropagation_descendants1 = (_props_rowSelectionPropagation2 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation2 === void 0 ? void 0 : _props_rowSelectionPropagation2.descendants) !== null && _props_rowSelectionPropagation_descendants1 !== void 0 ? _props_rowSelectionPropagation_descendants1 : false, (_props_rowSelectionPropagation_parents1 = (_props_rowSelectionPropagation3 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation3 === void 0 ? void 0 : _props_rowSelectionPropagation3.parents) !== null && _props_rowSelectionPropagation_parents1 !== void 0 ? _props_rowSelectionPropagation_parents1 : false, removeRow);
                    }
                }
            });
        }
        var isSelectionValid = newSelection.size < 2 || canHaveMultipleSelection;
        if (isSelectionValid) {
            apiRef.current.setRowSelectionModel(Array.from(newSelection));
        }
    }, [
        logger,
        applyAutoSelection,
        canHaveMultipleSelection,
        apiRef,
        tree,
        (_props_rowSelectionPropagation4 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation4 === void 0 ? void 0 : _props_rowSelectionPropagation4.descendants,
        (_props_rowSelectionPropagation5 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation5 === void 0 ? void 0 : _props_rowSelectionPropagation5.parents
    ]);
    var getPropagatedRowSelectionModel = React.useCallback(function(inputSelectionModel) {
        if (!isNestedData || !applyAutoSelection || inputSelectionModel.length === 0) {
            return inputSelectionModel;
        }
        var propagatedSelectionModel = new Set(inputSelectionModel);
        var addRow = function(rowId) {
            propagatedSelectionModel.add(rowId);
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = inputSelectionModel[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var _props_rowSelectionPropagation, _props_rowSelectionPropagation1;
                var _props_rowSelectionPropagation_descendants, _props_rowSelectionPropagation_parents;
                findRowsToSelect(apiRef, tree, id, (_props_rowSelectionPropagation_descendants = (_props_rowSelectionPropagation = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation === void 0 ? void 0 : _props_rowSelectionPropagation.descendants) !== null && _props_rowSelectionPropagation_descendants !== void 0 ? _props_rowSelectionPropagation_descendants : false, (_props_rowSelectionPropagation_parents = (_props_rowSelectionPropagation1 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation1 === void 0 ? void 0 : _props_rowSelectionPropagation1.parents) !== null && _props_rowSelectionPropagation_parents !== void 0 ? _props_rowSelectionPropagation_parents : false, addRow, propagatedSelectionModel);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return Array.from(propagatedSelectionModel);
    }, [
        apiRef,
        tree,
        (_props_rowSelectionPropagation6 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation6 === void 0 ? void 0 : _props_rowSelectionPropagation6.descendants,
        (_props_rowSelectionPropagation7 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation7 === void 0 ? void 0 : _props_rowSelectionPropagation7.parents,
        isNestedData,
        applyAutoSelection
    ]);
    var selectRowRange = React.useCallback(function(param) {
        var startId = param.startId, endId = param.endId, isSelected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, resetSelection = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) {
            return;
        }
        logger.debug("Expanding selection from row ".concat(startId, " to row ").concat(endId));
        // Using rows from all pages allow to select a range across several pages
        var allPagesRowIds = gridExpandedSortedRowIdsSelector(apiRef);
        var startIndex = allPagesRowIds.indexOf(startId);
        var endIndex = allPagesRowIds.indexOf(endId);
        var _ref = _sliced_to_array(startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ], 2), start = _ref[0], end = _ref[1];
        var rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    var selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    var selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange,
        getPropagatedRowSelectionModel: getPropagatedRowSelectionModel
    };
    useGridApiMethod(apiRef, selectionPublicApi, 'public');
    useGridApiMethod(apiRef, selectionPrivateApi, props.signature === GridSignature.DataGrid ? 'private' : 'public');
    /*
   * EVENTS
   */ var isFirstRender = React.useRef(true);
    var removeOutdatedSelection = React.useCallback(function() {
        var sortModelUpdated = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var _props_rowSelectionPropagation;
        if (isFirstRender.current) {
            return;
        }
        var currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
        var rowsLookup = gridRowsLookupSelector(apiRef);
        var filteredRowsLookup = gridFilteredRowsLookupSelector(apiRef);
        // We clone the existing object to avoid mutating the same object returned by the selector to others part of the project
        var selectionLookup = _extends({}, selectedIdsLookupSelector(apiRef));
        var isNonExistent = function(id) {
            if (props.filterMode === 'server') {
                return !rowsLookup[id];
            }
            return !rowsLookup[id] || filteredRowsLookup[id] === false;
        };
        var hasChanged = false;
        currentSelection.forEach(function(id) {
            var _props_rowSelectionPropagation;
            if (isNonExistent(id)) {
                if (props.keepNonExistentRowsSelected) {
                    return;
                }
                delete selectionLookup[id];
                hasChanged = true;
                return;
            }
            if (!((_props_rowSelectionPropagation = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation === void 0 ? void 0 : _props_rowSelectionPropagation.parents)) {
                return;
            }
            var node = tree[id];
            if (node.type === 'group') {
                var isAutoGenerated = node.isAutoGenerated;
                if (isAutoGenerated) {
                    delete selectionLookup[id];
                    hasChanged = true;
                    return;
                }
                // Keep previously selected tree data parents selected if all their children are filtered out
                if (!node.children.every(function(childId) {
                    return filteredRowsLookup[childId] === false;
                })) {
                    delete selectionLookup[id];
                    hasChanged = true;
                }
            }
        });
        // For nested data, on row tree updation (filtering, adding rows, etc.) when the selection is
        // not empty, we need to re-run scanning of the tree to propagate the selection changes
        // Example: A parent whose de-selected children are filtered out should now be selected
        var shouldReapplyPropagation = isNestedData && ((_props_rowSelectionPropagation = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation === void 0 ? void 0 : _props_rowSelectionPropagation.parents) && Object.keys(selectionLookup).length > 0;
        if (hasChanged || shouldReapplyPropagation && !sortModelUpdated) {
            var newSelection = Object.values(selectionLookup);
            if (shouldReapplyPropagation) {
                apiRef.current.selectRows(newSelection, true, true);
            } else {
                apiRef.current.setRowSelectionModel(newSelection);
            }
        }
    }, [
        apiRef,
        isNestedData,
        (_props_rowSelectionPropagation8 = props.rowSelectionPropagation) === null || _props_rowSelectionPropagation8 === void 0 ? void 0 : _props_rowSelectionPropagation8.parents,
        props.keepNonExistentRowsSelected,
        props.filterMode,
        tree
    ]);
    var handleSingleRowSelection = React.useCallback(function(id, event) {
        var hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        var isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !isKeyboardEvent(event);
        var resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        var isSelected = apiRef.current.isRowSelected(id);
        if (resetSelection) {
            apiRef.current.selectRow(id, !isMultipleSelectionDisabled ? !isSelected : true, true);
        } else {
            apiRef.current.selectRow(id, !isSelected, false);
        }
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    var handleRowClick = React.useCallback(function(params, event) {
        var _event_target_closest;
        if (disableRowSelectionOnClick) {
            return;
        }
        var field = (_event_target_closest = event.target.closest(".".concat(gridClasses.cell))) === null || _event_target_closest === void 0 ? void 0 : _event_target_closest.getAttribute('data-field');
        if (field === GRID_CHECKBOX_SELECTION_COL_DEF.field) {
            // click on checkbox should not trigger row selection
            return;
        }
        if (field === GRID_DETAIL_PANEL_TOGGLE_FIELD) {
            // click to open the detail panel should not select the row
            return;
        }
        if (field) {
            var column = apiRef.current.getColumn(field);
            if ((column === null || column === void 0 ? void 0 : column.type) === GRID_ACTIONS_COLUMN_TYPE) {
                return;
            }
        }
        var rowNode = gridRowTreeSelector(apiRef)[params.id];
        if (rowNode.type === 'pinnedRow') {
            return;
        }
        if (event.shiftKey && canHaveMultipleSelection) {
            expandMouseRowRangeSelection(params.id);
        } else {
            handleSingleRowSelection(params.id, event);
        }
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    var preventSelectionOnShift = React.useCallback(function(params, event) {
        if (canHaveMultipleSelection && event.shiftKey) {
            var _window_getSelection;
            (_window_getSelection = window.getSelection()) === null || _window_getSelection === void 0 ? void 0 : _window_getSelection.removeAllRanges();
        }
    }, [
        canHaveMultipleSelection
    ]);
    var handleRowSelectionCheckboxChange = React.useCallback(function(params, event) {
        if (canHaveMultipleSelection && event.nativeEvent.shiftKey) {
            expandMouseRowRangeSelection(params.id);
        } else {
            apiRef.current.selectRow(params.id, params.value, !canHaveMultipleSelection);
        }
    }, [
        apiRef,
        expandMouseRowRangeSelection,
        canHaveMultipleSelection
    ]);
    var handleHeaderSelectionCheckboxChange = React.useCallback(function(params) {
        var rowsToBeSelected = props.pagination && props.checkboxSelectionVisibleOnly && props.paginationMode === 'client' ? gridPaginatedVisibleSortedGridRowIdsSelector(apiRef) : gridExpandedSortedRowIdsSelector(apiRef);
        apiRef.current.selectRows(rowsToBeSelected, params.value);
    }, [
        apiRef,
        props.checkboxSelectionVisibleOnly,
        props.pagination,
        props.paginationMode
    ]);
    var handleCellKeyDown = React.useCallback(function(params, event) {
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === GridCellModes.Edit) {
            return;
        }
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if (isEventTargetInPortal(event)) {
            return;
        }
        if (isNavigationKey(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            var focusCell = gridFocusCellSelector(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                var isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                var newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                var previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                var start;
                var end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else {
                    // eslint-disable-next-line no-lonely-if
                    if (isNextRowSelected) {
                        // We are navigating to the top of the page and removing selected rows
                        start = newRowIndex + 1;
                        end = previousRowIndex;
                    } else {
                        // We are navigating to the top of the page and adding selected rows
                        start = newRowIndex;
                        end = previousRowIndex;
                    }
                }
                var visibleRows = getVisibleRows(apiRef);
                var rowsBetweenStartAndEnd = visibleRows.rows.slice(start, end + 1).map(function(row) {
                    return row.id;
                });
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === ' ' && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (String.fromCharCode(event.keyCode) === 'A' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            selectRows(apiRef.current.getAllRowIds(), true);
        }
    }, [
        apiRef,
        handleSingleRowSelection,
        selectRows,
        canHaveMultipleSelection
    ]);
    var syncControlledState = useEventCallback(function() {
        if (!props.rowSelection) {
            apiRef.current.setRowSelectionModel([]);
            return;
        }
        if (propRowSelectionModel === undefined) {
            return;
        }
        if (!applyAutoSelection || !isNestedData || propRowSelectionModel.length === 0) {
            apiRef.current.setRowSelectionModel(propRowSelectionModel);
            return;
        }
        var newSelectionModel = apiRef.current.getPropagatedRowSelectionModel(propRowSelectionModel);
        if (newSelectionModel.length !== propRowSelectionModel.length || !newSelectionModel.every(function(id) {
            return propRowSelectionModel.includes(id);
        })) {
            apiRef.current.setRowSelectionModel(newSelectionModel);
            return;
        }
        apiRef.current.setRowSelectionModel(propRowSelectionModel);
    });
    useGridApiEventHandler(apiRef, 'sortedRowsSet', runIfRowSelectionIsEnabled(function() {
        return removeOutdatedSelection(true);
    }));
    useGridApiEventHandler(apiRef, 'filteredRowsSet', runIfRowSelectionIsEnabled(function() {
        return removeOutdatedSelection();
    }));
    useGridApiEventHandler(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
    useGridApiEventHandler(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    useGridApiEventHandler(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    useGridApiEventHandler(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
    useGridApiEventHandler(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));
    /*
   * EFFECTS
   */ React.useEffect(function() {
        syncControlledState();
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection,
        syncControlledState
    ]);
    var isStateControlled = propRowSelectionModel != null;
    React.useEffect(function() {
        if (isStateControlled || !props.rowSelection) {
            return;
        }
        // props.isRowSelectable changed
        var currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
        if (isRowSelectable) {
            var newSelection = currentSelection.filter(function(id) {
                return isRowSelectable(id);
            });
            if (newSelection.length < currentSelection.length) {
                apiRef.current.setRowSelectionModel(newSelection);
            }
        }
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    React.useEffect(function() {
        if (!props.rowSelection || isStateControlled) {
            return;
        }
        var currentSelection = gridRowSelectionStateSelector(apiRef.current.state);
        if (!canHaveMultipleSelection && currentSelection.length > 1) {
            // See https://github.com/mui/mui-x/issues/8455
            apiRef.current.setRowSelectionModel([]);
        }
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
    React.useEffect(function() {
        runIfRowSelectionIsEnabled(removeOutdatedSelection);
    }, [
        removeOutdatedSelection,
        runIfRowSelectionIsEnabled
    ]);
    React.useEffect(function() {
        if (isFirstRender.current) {
            isFirstRender.current = false;
        }
    }, []);
};
